export default __webpack_public_path__ + "static/media/cccaaab75fa662322ba9413fa9e6493f.svg";